import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppShell } from "../../components/Sidebar";
import { ModuleDetailBody } from "../../components/ModuleDetail";
import { api } from "../../lib/api";
import { ChevronLeft, Loader2 } from "lucide-react";

export default function TeacherModuleDetail() {
  const { i18n } = useTranslation();
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    const lang = i18n.resolvedLanguage || "en";
    api.get(`/modules/${moduleId}/details?lang=${lang}`).then((r) => setData(r.data));
  }, [moduleId, i18n.resolvedLanguage]);

  return (
    <AppShell role="teacher">
      <button
        onClick={() => navigate("/teacher/modules")}
        data-testid="back-to-modules"
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-600 hover:text-indigo-700"
      >
        <ChevronLeft size={14} /> Back to Chapters
      </button>

      {!data ? (
        <div className="mt-10 flex items-center justify-center"><Loader2 className="animate-spin text-indigo-600" /></div>
      ) : (
        <div className="mt-4">
          <ModuleDetailBody data={data} prefLangCode={i18n.resolvedLanguage || "en"} />
        </div>
      )}
    </AppShell>
  );
}
